module.exports = __webpack_public_path__ + "static/media/info.16391094.svg";